import { h } from 'preact';

const Comic = () => (
  <svg style={{marginRight: "5px"}} width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  </svg>
);

export { Comic }